module.exports = __webpack_public_path__ + "media/apps/gif-android-34-673f0f63.gif";